import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './utils/AuthContext';  // Ensure this path is correct
import { ThemeProvider } from './utils/ThemeProvider'; // If ThemeProvider is used globally
import { ProjectProvider } from './utils/ProjectContext'; // If ProjectProvider is used globally
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider>  {/* Assuming ThemeProvider needs to wrap everything */}
            <AuthProvider>  {/* AuthProvider provides context for authentication */}
                <ProjectProvider>  {/* ProjectProvider provides context specific to project management */}
                    <App />
                </ProjectProvider>
            </AuthProvider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

